<template>
    <div class="modal">
        <span class="close" v-on:click="$emit('close')">x</span>
        <div class="modal-content">
            <h1 class="login-title">Prijava</h1>
            <span>Nemaš račun? <span class="register" v-on:click="$emit('showRegistrationModal')">Registriraj se &#10230;</span></span>
            <form id="login" v-on:submit.prevent="login()" novalidate="true">
                <div>
                    <input id="email" type="text" v-model="email" v-on:change="validateEmail()"/>
                    <label for="email" v-bind:class="email ? 'field-filled' : ''">Email adresa</label>
                    <a v-if="isEmailValid" class="reset-request" v-on:click="sendResetRequest">Zaboravljena lozinka?</a>
                    <div class="error" v-bind:style="{visibility: isEmailValid ? 'hidden' : 'visible'}">Upisana email adresa nije valjana.</div>
                    <div class="error" v-bind:style="{display: invalidResetAttempt ? 'block' : 'none'}">Moraš upisati e-mail za resetiranje.</div>
                    <div class="error" v-bind:style="{display: didResetSucceed ? 'none' : 'block'}">Zahtjev za reset neuspješan.</div>
                    <div class="success" v-bind:style="{display: didResetSucceed && isResetOver ? 'block' : 'none'}">
                        Zahtjev za resetiranjem je poslan. Provjeri e-mail i klikni na link da promijeniš svoju lozinku.
                    </div>
                </div>
                <div>
                    <input id="password" type="password" v-model="password" v-on:change="validatePassword()"/>
                    <label for="password" v-bind:class="password ? 'field-filled' : ''">Lozinka</label>
                    <div class="error" v-bind:style="{visibility: isPasswordValid ? 'hidden' : 'visible'}">Lozinka ne smije biti prazna.</div>
                    <div class="error" v-bind:style="{visibility: didLoginSucceed ? 'hidden' : 'visible'}">Prijava neuspješna: nepostojeća (ili neaktivna) email adresa ili pogrešna lozinka!</div>
                </div>
                <button class="button" type="submit" value="submit" v-bind:disabled="!isEmailValid || !isPasswordValid || !email || !password">PRIJAVA</button>
            </form>
        </div>
    </div>
</template>

<script>
    import { emailRegex } from '@/config';

    export default {
        name: 'LoginModal',
        data() {
            return {
                email: "",
                password: "",
                isEmailValid: true,
                isPasswordValid: true,
                didLoginSucceed: true,
                appUrl: "",
                didResetSucceed: true,
                isResetOver: false,
                isResetting: false,
                invalidResetAttempt: false
            }
        },
        methods: {
            validateEmail: function() {
                this.isEmailValid = emailRegex.test(this.email);
                this.didLoginSucceed = true;
            },
            validatePassword: function() {
                this.isPasswordValid = this.password;
                this.didLoginSucceed = true;
            },
            login: function() {
                this.$axios.post(`${this.$API_URL}/login`, {
                    email: this.email,
                    password: this.password
                }).then(response => {
                        localStorage.setItem('token', response.data);
                        let role = this.$decode(response.data).roles;
                        if(role === 'Administrator')
                            this.$router.push('/admin');
                        else
                            this.$router.push('/app');
                    }).catch(() => {
                        this.didLoginSucceed = false;
                        setTimeout(() => { this.didLoginSucceed = true; }, 3000);
                    });
            },
            sendResetRequest: function() {
                if(!this.email || !this.isEmailValid)
                {
                    this.invalidResetAttempt = true;
                    setTimeout(() => { this.invalidResetAttempt = false; }, 3000);
                    return;
                }

                if(!this.isResetting && this.email && this.isEmailValid)
                {
                    this.isResetting = true;
                    this.$axios.post(`${this.$API_URL}/user/reset-password-request`, {
                        userEmail: this.email,
                        appUrl: this.appUrl
                    }).then(() => {
                        this.isResetting = false;
                        this.isResetOver = true;
                        this.didResetSucceed = true;       
                    }).catch(() => {
                        this.isResetting = false;
                        this.didResetSucceed = false;
                        setTimeout(() => { this.didResetSucceed = true; }, 3000);
                    });
                }
            }
        },
        created() {
            this.appUrl = `${window.location.protocol}//${window.location.host}`;
        },
        mounted() {
            document.body.classList.add('modal-open');
        },
        beforeDestroy() {
            document.body.classList.remove('modal-open');
        }
    }
</script>

<style scoped>
    .modal-content {
        position: absolute;
        left: 25%;
        max-width: 350px;
    }

    .login-title {
        font-family: "Fuse V.2 Display";
        font-size: 36px;
        font-weight: 800;
        margin-bottom: 20px;
    }

    .login-title span {
        margin-top: 10px;
    }

    input {
        border: none;
        background-color: #f9f9f9;
        border-bottom: 2px solid black;
        font-size: 20px;
        padding: 18px 0 5px 20px;
        width: 100%;
        outline: none;
    }

    form > div {
        position: relative;
    }

    form > div > label {
        position: absolute;
        font-size: 16px;
        left: 20px;
        top: 34px;
        opacity: 0.7;
    }

    form > div input:focus + label,
    form > div > label.field-filled {
        font-size: 14px;
        top: 22px;
        opacity: 0.6;
    }

    input:focus {
        border-bottom-color: #30cec1;
    }

    .register,
    .close {
        color: #30cec1;
    }

    .close {
        font-size: 64px;
        font-weight: 300;
        transform:scale(1.4,1);
        position: absolute;
        right: 10%;
        top: 10%;
    }

    .register:hover,
    .close:hover {
        cursor: pointer;
    }

    #login {
        display: flex;
        flex-direction: column;
    }

    #login input {
        margin-top: 20px;
    }

    .button {
        margin-right: auto;
    }

    .reset-request {
        display: inline-block;
        margin-top: 5px;
        margin-left: 5px;
        font-size: 12px;
        opacity: 0.6;
        user-select: none;
    }

    .reset-request:hover {
        opacity: 1;
        cursor: pointer;
    }

    @media screen and (max-width: 764px) {
        input {
            font-size: 28px;
        }

        form {
            padding-right: 10%;
        }

        form > div > label {
            top: 40px;
        }
    }

    @media screen and (max-width: 480px) {
        .login-title {
            flex-direction: column;
            align-items: flex-start;
        }

        input {
            font-size: 24px;
        }
    }

    @media screen and (max-width: 420px) {
        .modal-content {
            left: 5%;
            max-width: 300px;
        }
    }
</style>